const DEFAULT_POINTER_HEIGHT = 0;

const UNSELECTED_IDX = -1;
const TOP = 0;

export default {
   data() {
      return {
         typeAheadPointer: UNSELECTED_IDX
      };
   },

   watch: {
      list() {
         this.typeAheadPointer = UNSELECTED_IDX;
         this.scrollTo();
      },
      text() {
         this.typeAheadPointer = UNSELECTED_IDX;
         this.scrollTo();
      },
      isOpen() {
         this.typeAheadPointer = UNSELECTED_IDX;
         this.scrollTo();
      }
   },

   methods: {
      typeAheadUp() {
         if (!this.isOpen) {
            this.activate();
         // eslint-disable-next-line no-magic-numbers
         } else if (this.typeAheadPointer > 0) {
            this.typeAheadPointer--;
            this.maybeAdjustScroll();
         }
      },

      typeAheadDown() {
         if (!this.isOpen) {
            this.activate();
         // eslint-disable-next-line no-magic-numbers
         } else if (this.typeAheadPointer < this.list.length - 1) {
            this.typeAheadPointer++;
            this.maybeAdjustScroll();
         }
      },

      typeAheadSelect() {
         if (this.list[this.typeAheadPointer]) {
            this.select(this.list[this.typeAheadPointer]);
         }
      },

      maybeAdjustScroll() {
         let pixelsToPointerTop = this.pixelsToPointerTop();
         let pixelsToPointerBottom = this.pixelsToPointerBottom();

         if (pixelsToPointerTop <= this.viewport().top) {
            return this.scrollTo(pixelsToPointerTop);
         } else if (pixelsToPointerBottom >= this.viewport().bottom) {
            return this.scrollTo(this.viewport().top + this.pointerHeight());
         }
         return null;
      },

      pixelsToPointerTop() {
         let pixelsToPointerTop = 0;
         for (let i = 0; i < this.typeAheadPointer; i++) {
            pixelsToPointerTop += this.$refs.list.children[i].offsetHeight;
         }
         return pixelsToPointerTop;
      },

      pixelsToPointerBottom() {
         return this.pixelsToPointerTop() + this.pointerHeight();
      },

      pointerHeight() {
         let element = this.$refs.list.children[this.typeAheadPointer];
         return element ? element.offsetHeight : DEFAULT_POINTER_HEIGHT;
      },

      viewport() {
         return {
            top: this.$refs.list.scrollTop,
            bottom: this.$refs.list.offsetHeight + this.$refs.list.scrollTop
         };
      },

      scrollTo(position = TOP) {
         if (this.$refs.list) {
            this.$refs.list.scrollTop = position;
         }
      }
   }
};
